import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_2 = { class: "card-header border-0" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-bolder m-0" }
const _hoisted_5 = { class: "collapse show" }
const _hoisted_6 = { class: "card-body border-top p-9" }
const _hoisted_7 = {
  class: "accordion",
  id: "seoAccordion"
}
const _hoisted_8 = { class: "accordion-item" }
const _hoisted_9 = {
  class: "accordion-header",
  id: "englishHeading"
}
const _hoisted_10 = {
  class: "accordion-button fs-4 fw-bold",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#englishCollapse",
  "aria-expanded": "true",
  "aria-controls": "englishCollapse"
}
const _hoisted_11 = {
  id: "englishCollapse",
  class: "accordion-collapse collapse show",
  "aria-labelledby": "englishHeading",
  "data-bs-parent": "#seoAccordion"
}
const _hoisted_12 = { class: "accordion-body" }
const _hoisted_13 = { class: "row mb-6" }
const _hoisted_14 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_15 = { class: "col-lg-8 fv-row" }
const _hoisted_16 = { class: "fv-plugins-message-container" }
const _hoisted_17 = { class: "fv-help-block" }
const _hoisted_18 = { class: "row mb-6" }
const _hoisted_19 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_20 = { class: "col-lg-8 fv-row" }
const _hoisted_21 = { class: "fv-plugins-message-container" }
const _hoisted_22 = { class: "fv-help-block" }
const _hoisted_23 = { class: "row mb-6" }
const _hoisted_24 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_25 = { class: "col-lg-8 fv-row" }
const _hoisted_26 = { class: "fv-plugins-message-container" }
const _hoisted_27 = { class: "fv-help-block" }
const _hoisted_28 = { class: "row mb-6" }
const _hoisted_29 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_30 = { class: "col-lg-8 fv-row" }
const _hoisted_31 = { class: "fv-plugins-message-container" }
const _hoisted_32 = { class: "fv-help-block" }
const _hoisted_33 = { class: "row mb-6" }
const _hoisted_34 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_35 = { class: "col-lg-8 fv-row" }
const _hoisted_36 = { class: "fv-plugins-message-container" }
const _hoisted_37 = { class: "fv-help-block" }
const _hoisted_38 = { class: "row mb-6" }
const _hoisted_39 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_40 = { class: "col-lg-8 fv-row" }
const _hoisted_41 = { class: "fv-plugins-message-container" }
const _hoisted_42 = { class: "fv-help-block" }
const _hoisted_43 = { class: "row mb-6" }
const _hoisted_44 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_45 = { class: "col-lg-8 fv-row d-flex align-items-center" }
const _hoisted_46 = { class: "fv-plugins-message-container" }
const _hoisted_47 = { class: "fv-help-block" }
const _hoisted_48 = { class: "row mb-6" }
const _hoisted_49 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_50 = { class: "col-lg-8 fv-row d-flex align-items-center" }
const _hoisted_51 = { class: "fv-plugins-message-container" }
const _hoisted_52 = { class: "fv-help-block" }
const _hoisted_53 = { class: "row mb-6" }
const _hoisted_54 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_55 = { class: "col-lg-8 fv-row" }
const _hoisted_56 = { class: "fv-plugins-message-container" }
const _hoisted_57 = { class: "fv-help-block" }
const _hoisted_58 = { class: "accordion-item" }
const _hoisted_59 = {
  class: "accordion-header",
  id: "arabicHeading"
}
const _hoisted_60 = {
  class: "accordion-button collapsed fs-4 fw-bold",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#arabicCollapse",
  "aria-expanded": "false",
  "aria-controls": "arabicCollapse"
}
const _hoisted_61 = {
  id: "arabicCollapse",
  class: "accordion-collapse collapse",
  "aria-labelledby": "arabicHeading",
  "data-bs-parent": "#seoAccordion"
}
const _hoisted_62 = { class: "accordion-body" }
const _hoisted_63 = { class: "row mb-6" }
const _hoisted_64 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_65 = { class: "col-lg-8 fv-row" }
const _hoisted_66 = { class: "fv-plugins-message-container" }
const _hoisted_67 = { class: "fv-help-block" }
const _hoisted_68 = { class: "row mb-6" }
const _hoisted_69 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_70 = { class: "col-lg-8 fv-row" }
const _hoisted_71 = { class: "fv-plugins-message-container" }
const _hoisted_72 = { class: "fv-help-block" }
const _hoisted_73 = { class: "row mb-6" }
const _hoisted_74 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_75 = { class: "col-lg-8 fv-row" }
const _hoisted_76 = { class: "fv-plugins-message-container" }
const _hoisted_77 = { class: "fv-help-block" }
const _hoisted_78 = { class: "row mb-6" }
const _hoisted_79 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_80 = { class: "col-lg-8 fv-row" }
const _hoisted_81 = { class: "fv-plugins-message-container" }
const _hoisted_82 = { class: "fv-help-block" }
const _hoisted_83 = { class: "row mb-6" }
const _hoisted_84 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_85 = { class: "col-lg-8 fv-row" }
const _hoisted_86 = { class: "fv-plugins-message-container" }
const _hoisted_87 = { class: "fv-help-block" }
const _hoisted_88 = { class: "row mb-6" }
const _hoisted_89 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_90 = { class: "col-lg-8 fv-row" }
const _hoisted_91 = { class: "fv-plugins-message-container" }
const _hoisted_92 = { class: "fv-help-block" }
const _hoisted_93 = { class: "row mb-6" }
const _hoisted_94 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_95 = { class: "col-lg-8 fv-row d-flex align-items-center" }
const _hoisted_96 = { class: "fv-plugins-message-container" }
const _hoisted_97 = { class: "fv-help-block" }
const _hoisted_98 = { class: "row mb-6" }
const _hoisted_99 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_100 = { class: "col-lg-8 fv-row d-flex align-items-center" }
const _hoisted_101 = { class: "fv-plugins-message-container" }
const _hoisted_102 = { class: "fv-help-block" }
const _hoisted_103 = { class: "row mb-6" }
const _hoisted_104 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_105 = { class: "col-lg-8 fv-row" }
const _hoisted_106 = { class: "fv-plugins-message-container" }
const _hoisted_107 = { class: "fv-help-block" }
const _hoisted_108 = { class: "card-footer d-flex justify-content-end py-6 px-9" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_MonacoEditor = _resolveComponent("MonacoEditor")!
  const _component_Form = _resolveComponent("Form")!

  return (_ctx.can('read', 'auctions'))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.translate('seoConfiguration')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_Form, {
            class: "form",
            onSubmit: _ctx.onSubmitBoth
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("h2", _hoisted_9, [
                      _createElementVNode("button", _hoisted_10, _toDisplayString(_ctx.translate('englishSeo')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.translate('seoTitleEn')), 1),
                          _createElementVNode("div", _hoisted_15, [
                            _createVNode(_component_Field, {
                              type: "text",
                              name: "seoTitleEn",
                              class: "form-control form-control-lg form-control-solid",
                              placeholder: _ctx.translate('seoTitleEn'),
                              modelValue: _ctx.seoDataEn.seoTitle,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.seoDataEn.seoTitle) = $event))
                            }, null, 8, ["placeholder", "modelValue"]),
                            _createElementVNode("div", _hoisted_16, [
                              _createElementVNode("div", _hoisted_17, [
                                _createVNode(_component_ErrorMessage, { name: "seoTitleEn" })
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.translate('seoDescriptionEn')), 1),
                          _createElementVNode("div", _hoisted_20, [
                            _createVNode(_component_Field, {
                              as: "textarea",
                              name: "seoDescriptionEn",
                              class: "form-control form-control-lg form-control-solid",
                              placeholder: _ctx.translate('seoDescriptionEn'),
                              style: {"height":"150px","resize":"vertical"},
                              modelValue: _ctx.seoDataEn.seoDescription,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.seoDataEn.seoDescription) = $event))
                            }, null, 8, ["placeholder", "modelValue"]),
                            _createElementVNode("div", _hoisted_21, [
                              _createElementVNode("div", _hoisted_22, [
                                _createVNode(_component_ErrorMessage, { name: "seoDescriptionEn" })
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_23, [
                          _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.translate('seoKeywordsEn')), 1),
                          _createElementVNode("div", _hoisted_25, [
                            _createVNode(_component_Field, {
                              as: "textarea",
                              name: "seoKeywordsEn",
                              class: "form-control form-control-lg form-control-solid",
                              placeholder: _ctx.translate('seoKeywordsEn'),
                              style: {"height":"150px","resize":"vertical"},
                              modelValue: _ctx.seoDataEn.seoKeywords,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.seoDataEn.seoKeywords) = $event))
                            }, null, 8, ["placeholder", "modelValue"]),
                            _createElementVNode("div", _hoisted_26, [
                              _createElementVNode("div", _hoisted_27, [
                                _createVNode(_component_ErrorMessage, { name: "seoKeywordsEn" })
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_28, [
                          _createElementVNode("label", _hoisted_29, _toDisplayString(_ctx.translate('seoSlugEn')), 1),
                          _createElementVNode("div", _hoisted_30, [
                            _createVNode(_component_Field, {
                              type: "text",
                              name: "seoSlugEn",
                              class: "form-control form-control-lg form-control-solid",
                              placeholder: _ctx.translate('seoSlugEn'),
                              modelValue: _ctx.seoDataEn.seoSlug,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.seoDataEn.seoSlug) = $event))
                            }, null, 8, ["placeholder", "modelValue"]),
                            _createElementVNode("div", _hoisted_31, [
                              _createElementVNode("div", _hoisted_32, [
                                _createVNode(_component_ErrorMessage, { name: "seoSlugEn" })
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_33, [
                          _createElementVNode("label", _hoisted_34, _toDisplayString(_ctx.translate('seoCanonicalUrl')), 1),
                          _createElementVNode("div", _hoisted_35, [
                            _createVNode(_component_Field, {
                              type: "text",
                              name: "seoCanonicalUrl",
                              class: "form-control form-control-lg form-control-solid",
                              placeholder: _ctx.translate('seoCanonicalUrl'),
                              modelValue: _ctx.seoDataEn.seoCanonicalUrl,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.seoDataEn.seoCanonicalUrl) = $event))
                            }, null, 8, ["placeholder", "modelValue"]),
                            _createElementVNode("div", _hoisted_36, [
                              _createElementVNode("div", _hoisted_37, [
                                _createVNode(_component_ErrorMessage, { name: "seoCanonicalUrl" })
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_38, [
                          _createElementVNode("label", _hoisted_39, _toDisplayString(_ctx.translate('seoImageAlt')), 1),
                          _createElementVNode("div", _hoisted_40, [
                            _createVNode(_component_Field, {
                              type: "text",
                              name: "seoImageAlt",
                              class: "form-control form-control-lg form-control-solid",
                              placeholder: _ctx.translate('seoImageAlt'),
                              modelValue: _ctx.seoDataEn.seoImageAlt,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.seoDataEn.seoImageAlt) = $event))
                            }, null, 8, ["placeholder", "modelValue"]),
                            _createElementVNode("div", _hoisted_41, [
                              _createElementVNode("div", _hoisted_42, [
                                _createVNode(_component_ErrorMessage, { name: "seoImageAlt" })
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_43, [
                          _createElementVNode("label", _hoisted_44, _toDisplayString(_ctx.translate('seoNoIndex')), 1),
                          _createElementVNode("div", _hoisted_45, [
                            _withDirectives(_createElementVNode("input", {
                              type: "checkbox",
                              name: "seoNoIndex",
                              class: "form-check-input me-2",
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.seoNoIndexEn) = $event))
                            }, null, 512), [
                              [_vModelCheckbox, _ctx.seoNoIndexEn]
                            ]),
                            _createElementVNode("div", _hoisted_46, [
                              _createElementVNode("div", _hoisted_47, [
                                _createVNode(_component_ErrorMessage, { name: "seoNoIndex" })
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_48, [
                          _createElementVNode("label", _hoisted_49, _toDisplayString(_ctx.translate('seoNoFollow')), 1),
                          _createElementVNode("div", _hoisted_50, [
                            _withDirectives(_createElementVNode("input", {
                              type: "checkbox",
                              name: "seoNoFollow",
                              class: "form-check-input me-2",
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.seoNoFollowEn) = $event))
                            }, null, 512), [
                              [_vModelCheckbox, _ctx.seoNoFollowEn]
                            ]),
                            _createElementVNode("div", _hoisted_51, [
                              _createElementVNode("div", _hoisted_52, [
                                _createVNode(_component_ErrorMessage, { name: "seoNoFollow" })
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_53, [
                          _createElementVNode("label", _hoisted_54, _toDisplayString(_ctx.translate('seoSchema')), 1),
                          _createElementVNode("div", _hoisted_55, [
                            _createVNode(_component_MonacoEditor, {
                              language: "json",
                              theme: "vs-dark",
                              class: "w-100",
                              style: {"height":"400px"},
                              value: _ctx.seoSchemaEnJson,
                              "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.seoSchemaEnJson) = $event))
                            }, null, 8, ["value"]),
                            _createElementVNode("div", _hoisted_56, [
                              _createElementVNode("div", _hoisted_57, [
                                _createVNode(_component_ErrorMessage, { name: "seoSchema" })
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_58, [
                    _createElementVNode("h2", _hoisted_59, [
                      _createElementVNode("button", _hoisted_60, _toDisplayString(_ctx.translate('arabicSeo')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_61, [
                      _createElementVNode("div", _hoisted_62, [
                        _createElementVNode("div", _hoisted_63, [
                          _createElementVNode("label", _hoisted_64, _toDisplayString(_ctx.translate('seoTitleAr')), 1),
                          _createElementVNode("div", _hoisted_65, [
                            _createVNode(_component_Field, {
                              type: "text",
                              name: "seoTitleAr",
                              class: "form-control form-control-lg form-control-solid text-end",
                              dir: "rtl",
                              placeholder: _ctx.translate('seoTitleAr'),
                              modelValue: _ctx.seoDataAr.seoTitle,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.seoDataAr.seoTitle) = $event))
                            }, null, 8, ["placeholder", "modelValue"]),
                            _createElementVNode("div", _hoisted_66, [
                              _createElementVNode("div", _hoisted_67, [
                                _createVNode(_component_ErrorMessage, { name: "seoTitleAr" })
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_68, [
                          _createElementVNode("label", _hoisted_69, _toDisplayString(_ctx.translate('seoDescriptionAr')), 1),
                          _createElementVNode("div", _hoisted_70, [
                            _createVNode(_component_Field, {
                              as: "textarea",
                              name: "seoDescriptionAr",
                              class: "form-control form-control-lg form-control-solid text-end",
                              dir: "rtl",
                              placeholder: _ctx.translate('seoDescriptionAr'),
                              style: {"height":"150px","resize":"vertical"},
                              modelValue: _ctx.seoDataAr.seoDescription,
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.seoDataAr.seoDescription) = $event))
                            }, null, 8, ["placeholder", "modelValue"]),
                            _createElementVNode("div", _hoisted_71, [
                              _createElementVNode("div", _hoisted_72, [
                                _createVNode(_component_ErrorMessage, { name: "seoDescriptionAr" })
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_73, [
                          _createElementVNode("label", _hoisted_74, _toDisplayString(_ctx.translate('seoKeywordsAr')), 1),
                          _createElementVNode("div", _hoisted_75, [
                            _createVNode(_component_Field, {
                              as: "textarea",
                              name: "seoKeywordsAr",
                              class: "form-control form-control-lg form-control-solid",
                              placeholder: _ctx.translate('seoKeywordsAr'),
                              style: {"height":"150px","resize":"vertical"},
                              modelValue: _ctx.seoDataAr.seoKeywords,
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.seoDataAr.seoKeywords) = $event))
                            }, null, 8, ["placeholder", "modelValue"]),
                            _createElementVNode("div", _hoisted_76, [
                              _createElementVNode("div", _hoisted_77, [
                                _createVNode(_component_ErrorMessage, { name: "seoKeywordsAr" })
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_78, [
                          _createElementVNode("label", _hoisted_79, _toDisplayString(_ctx.translate('seoSlugAr')), 1),
                          _createElementVNode("div", _hoisted_80, [
                            _createVNode(_component_Field, {
                              type: "text",
                              name: "seoSlugAr",
                              class: "form-control form-control-lg form-control-solid text-end",
                              dir: "rtl",
                              placeholder: _ctx.translate('seoSlugAr'),
                              modelValue: _ctx.seoDataAr.seoSlug,
                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.seoDataAr.seoSlug) = $event))
                            }, null, 8, ["placeholder", "modelValue"]),
                            _createElementVNode("div", _hoisted_81, [
                              _createElementVNode("div", _hoisted_82, [
                                _createVNode(_component_ErrorMessage, { name: "seoSlugAr" })
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_83, [
                          _createElementVNode("label", _hoisted_84, _toDisplayString(_ctx.translate('seoCanonicalUrl')), 1),
                          _createElementVNode("div", _hoisted_85, [
                            _createVNode(_component_Field, {
                              type: "text",
                              name: "seoCanonicalUrl",
                              class: "form-control form-control-lg form-control-solid",
                              placeholder: _ctx.translate('seoCanonicalUrl'),
                              modelValue: _ctx.seoDataEn.seoCanonicalUrl,
                              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.seoDataEn.seoCanonicalUrl) = $event))
                            }, null, 8, ["placeholder", "modelValue"]),
                            _createElementVNode("div", _hoisted_86, [
                              _createElementVNode("div", _hoisted_87, [
                                _createVNode(_component_ErrorMessage, { name: "seoCanonicalUrl" })
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_88, [
                          _createElementVNode("label", _hoisted_89, _toDisplayString(_ctx.translate('seoImageAlt')), 1),
                          _createElementVNode("div", _hoisted_90, [
                            _createVNode(_component_Field, {
                              type: "text",
                              name: "seoImageAlt",
                              class: "form-control form-control-lg form-control-solid",
                              placeholder: _ctx.translate('seoImageAlt'),
                              modelValue: _ctx.seoDataEn.seoImageAlt,
                              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.seoDataEn.seoImageAlt) = $event))
                            }, null, 8, ["placeholder", "modelValue"]),
                            _createElementVNode("div", _hoisted_91, [
                              _createElementVNode("div", _hoisted_92, [
                                _createVNode(_component_ErrorMessage, { name: "seoImageAlt" })
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_93, [
                          _createElementVNode("label", _hoisted_94, _toDisplayString(_ctx.translate('seoNoFollow')), 1),
                          _createElementVNode("div", _hoisted_95, [
                            _withDirectives(_createElementVNode("input", {
                              type: "checkbox",
                              name: "seoNoFollow",
                              class: "form-check-input me-2",
                              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.seoNoFollowAr) = $event))
                            }, null, 512), [
                              [_vModelCheckbox, _ctx.seoNoFollowAr]
                            ]),
                            _createElementVNode("div", _hoisted_96, [
                              _createElementVNode("div", _hoisted_97, [
                                _createVNode(_component_ErrorMessage, { name: "seoNoFollow" })
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_98, [
                          _createElementVNode("label", _hoisted_99, _toDisplayString(_ctx.translate('seoNoIndex')), 1),
                          _createElementVNode("div", _hoisted_100, [
                            _withDirectives(_createElementVNode("input", {
                              type: "checkbox",
                              name: "seoNoIndex",
                              class: "form-check-input me-2",
                              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.seoNoIndexAr) = $event))
                            }, null, 512), [
                              [_vModelCheckbox, _ctx.seoNoIndexAr]
                            ]),
                            _createElementVNode("div", _hoisted_101, [
                              _createElementVNode("div", _hoisted_102, [
                                _createVNode(_component_ErrorMessage, { name: "seoNoIndex" })
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_103, [
                          _createElementVNode("label", _hoisted_104, _toDisplayString(_ctx.translate('seoSchema')), 1),
                          _createElementVNode("div", _hoisted_105, [
                            _createVNode(_component_MonacoEditor, {
                              language: "json",
                              theme: "vs-dark",
                              class: "w-100",
                              style: {"height":"400px"},
                              value: _ctx.seoSchemaArJson,
                              "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.seoSchemaArJson) = $event))
                            }, null, 8, ["value"]),
                            _createElementVNode("div", _hoisted_106, [
                              _createElementVNode("div", _hoisted_107, [
                                _createVNode(_component_ErrorMessage, { name: "seoSchema" })
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_108, [
                _createElementVNode("button", {
                  type: "reset",
                  class: "btn btn-white btn-active-light-primary me-2",
                  onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
                }, _toDisplayString(_ctx.translate('discard')), 1),
                _createElementVNode("button", {
                  type: "submit",
                  class: "btn btn-primary",
                  id: "kt_account_profile_details_submit",
                  ref: "submitButton"
                }, _toDisplayString(_ctx.translate('saveChanges')), 513)
              ])
            ]),
            _: 1
          }, 8, ["onSubmit"])
        ])
      ]))
    : _createCommentVNode("", true)
}